import { render, staticRenderFns } from "./ComponentsTemplatesFooter.vue?vue&type=template&id=7096edb7&scoped=true"
import script from "./ComponentsTemplatesFooter.vue?vue&type=script&lang=js"
export * from "./ComponentsTemplatesFooter.vue?vue&type=script&lang=js"
import style0 from "./ComponentsTemplatesFooter.vue?vue&type=style&index=0&id=7096edb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7096edb7",
  null
  
)

export default component.exports